import { getSalesLatestCost, getCalcSalesCost, getCalcSalesCostByID, getCalcSalesCostAnalyzeByID, calcSalesCostById, calcAllSalesCost } from '@/api/caclSalesCost'
import Vue from 'vue'

const state = {
  salesLatestCost: [],
  calcCost: [],
  salesCostAnalyze: [],
  totalCounts: 0,
  calcCostTotal:0,
}

const actions = {
  async getSalesLatestCostAction({ commit }, payload) {
    try {
      const res = await getSalesLatestCost(payload)
      if (res.success) {
        commit('SET_SALES_LATEST_COST', res.data)
        return res.data
      } else {
        throw res
      }
    } catch (error) {
      throw error
    }
  },
  async getCalcSalesCostAction({ commit }, payload) {
    try {
      const res = await getCalcSalesCost(payload)
      commit('SET_CALC_COST', res.data)
      return res.data
    } catch (error) {
      throw error
    }
  },

  async getCalcSalesCostByIDAction({ commit }, payload) {
    try {
      const res = await getCalcSalesCostByID(payload)
      return res.data
    } catch (error) {
      throw error
    }
  },

  async getCalcSalesCostAnalyzeByIDAction({ commit }, payload) {
    try {
      const res = await getCalcSalesCostAnalyzeByID(payload.id, payload.data)
      commit('SET_SALES_COST_ANALYZE', res.data)
      return res.data
    } catch (error) {
      throw error
    }
  },

  async calcAllSalesCostAction({ commit }, payload) {
    try {
      await calcAllSalesCost(payload)
    } catch (error) {
      throw error
    }
  },

  async calcSalesCostByIdAction({ commit }, payload) {
    try {
      const res = await calcSalesCostById(payload)
      commit('UPDATE_SALES_LATEST_COST', res.data.sales)
      return res.data.result
    } catch (error) {
      throw error
    }
  },
  async updateOneAction({ commit }, payload) {
    try {
      commit('UPDATE_ONE_SALES_LATEST_COST', payload.row)
    } catch (error) {
      throw error
    }
  },
}

const mutations = {
  SET_SALES_LATEST_COST(state, payload) {
    payload.sales.forEach(x => {
      x.isPriceEdit = false
      x.isTransPriceEdit = false
      x.isPromoFeeEdit = false
      x.isJDEdit = false
      if (!x.calcSalesCost&&x.promoFee) {
        x.promoFeeSum = x.promoFee.reduce((p, c) => {
          return p + c.fee;
        }, 0);
      }
      return
    });
    state.salesLatestCost = payload.sales
    state.totalCounts = payload.totalCounts
  },
  SET_CALC_COST(state, payload) {
    state.calcCost = payload.receiveList
    state.calcCostTotal = payload.totalCounts
  },
  UPDATE_SALES_LATEST_COST(state, payload) {
    Vue.set(state.salesLatestCost, state.salesLatestCost.findIndex(x => x._id === payload._id), payload);
  },
  UPDATE_ONE_SALES_LATEST_COST(state, payload) {
    Vue.set(state.salesLatestCost, state.salesLatestCost.findIndex(x => x._id === payload._id), payload);
  },

  SET_SALES_COST_ANALYZE(state, payload) {
    state.salesCostAnalyze = payload.salesCostList
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}